// src/hocs/withEnvSwitch.js
import React from "react";
import { isProdEnv } from "../env-utils";

export default function withEnvSwitch(ProdComp, NonProdComp) {
  return function EnvSwitched(props) {
    const isProd = isProdEnv()
    const Component = isProd ? ProdComp : NonProdComp;
    if (!Component) return null;
    return <Component {...props} />;
  };
}
